export enum ConnectionStatus {
  NotConnected,
  Pending,
  Connected,
}
